import React from "react";
import {
  FaCoins,
  FaGavel,
  FaUsers,
  FaExchangeAlt,
  FaBullhorn,
} from "react-icons/fa";

function STOFeature({ icon: Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6 process-two-single pt-4">
      <div className="services-style-two-item fade-up-anim">
        <div className="top-info text-center">
          <div className="content d-flex flex-column items-center pb-3">
            <Icon size={40} />
          </div>
          <h4>
            <a>{title}</a>
          </h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

function TokenCreation() {
  const features = [
    {
      title: "Token Creation & Issuance",
      description:
        "Launch custom security tokens on your preferred blockchain, ensuring tokens align with regulatory requirements and provide full asset control.",
      icon: FaCoins,
    },
    {
      title: "Regulatory Compliance",
      description:
        "We provide KYC/AML integration, regulatory guidance, and jurisdictional compliance for legally sound STOs.",
      icon: FaGavel,
    },
    {
      title: "Investor Management Platform",
      description:
        "Build a seamless investor onboarding experience with dashboards, automated KYC, and real-time reporting on token performance.",
      icon: FaUsers,
    },
    {
      title: "Secondary Market Integration",
      description:
        "Enable token liquidity with seamless integration into approved secondary markets and exchanges for easy trading post-STO.",
      icon: FaExchangeAlt,
    },
    {
      title: "Token Marketing & Outreach",
      description:
        "Our STO experts help you build trust with potential investors through focused outreach and digital marketing strategies that enhance your offering's visibility.",
      icon: FaBullhorn,
    },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                STO Development Services
              </h2>
            </div>
          </div>
        </div>
        <div className="row fade-up-anim justify-content-center">
          {features.map((feature, idx) => (
            <STOFeature key={idx} {...feature} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TokenCreation;
